export const TABLE_TOOLTIP_ENTER_DELAY_MS = 500;
